import { Action } from '@ngrx/store';
import { NotificationTemplateInterface } from 'app/notifications/models';

import { NotificationActionType } from '.';

export class DeleteNotificationTemplate implements Action {
  public readonly type: NotificationActionType = NotificationActionType.DeleteNotificationTemplate;

  constructor(public readonly payload: NotificationTemplateInterface) { }
}

export class DeleteNotificationTemplateComplete implements Action {
  public readonly type: NotificationActionType = NotificationActionType.DeleteNotificationTemplateComplete;

  constructor(public readonly payload: NotificationTemplateInterface) { }
}

export class DeleteNotificationTemplateFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.DeleteNotificationTemplateFailed;

  constructor(public readonly payload: string) { }
}
